import { createRoot } from 'react-dom/client';

import browser from '@openclassrooms/utils/browser';

import AppProviders from 'Modules/webapp/components/AppProviders';

import FlashMessage from '../components/FlashMessage';

function popMessage(message, status) {
  const container = browser.document.createElement('div');
  browser.document.body.appendChild(container);
  const root = createRoot(container);
  root.render(
    <AppProviders productionPrefix="notifications-flashMessages">
      <FlashMessage status={status} htmlContent={message} />
    </AppProviders>
  );
}

export default popMessage;
